var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.927 34H16.12V21.982h3.808zm-1.906-13.657c-1.217 0-2.205-.988-2.205-2.182 0-.573.232-1.123.646-1.528a2.23 2.23 0 0 1 1.56-.633c.584 0 1.145.228 1.559.633s.646.955.646 1.528c0 1.194-.988 2.182-2.206 2.182M34.18 34h-3.8v-5.85c0-1.394-.029-3.182-1.98-3.182-1.98 0-2.283 1.514-2.283 3.081V34h-3.804V21.982h3.652v1.64h.053c.509-.945 1.75-1.941 3.603-1.941 3.854 0 4.563 2.487 4.563 5.717V34z"
  })));
};
export default SvgLinkedin;